import axios from "axios";
import { GetToken } from "./auth";

const api = axios.create({
    baseURL: "http://191.252.38.138/api", //producao
    // baseURL: "http://localhost:5000/api", //dev
});

api.interceptors.request.use(async config => {
    const token = GetToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;
